//@Actions
const actionTypes = require('constants/actionTypes');

const {
    TYPE_PLANS,
    TYPE_ETFS,
    TYPE_FUNDS,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_STOCKS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_FUNDS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_WARRANTS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_ETFS,
    BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_PLANS
} = require('constants/index');

const clearResultsTracking = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_CLEAR_TRACKING
    });
};

const advancedSearchFiltersTracking = () => (dispatch, getState) => {
    const filtersSearch = getState().brokerProductFiltersSearch.get('search');
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_FILTERS_TRACKING,
        payload: {
            filtersSearch
        }
    });
};

const getTypeLabel = (type) => {
    switch (type) {
        case TYPE_PLANS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_PLANS;
        case TYPE_ETFS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_ETFS;
        case TYPE_FUNDS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_FUNDS;
        case TYPE_WARRANTS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_WARRANTS;
        case TYPE_STOCKS:
            return BROKER_SEARCH_WIDGET_UTAG_VIEW_ALL_STOCKS;
    }
}

const searchSpecificProductTracking = (type) => (dispatch) => {
    const typeLabel = getTypeLabel(type);
    dispatch ({
        type: actionTypes.BROKER_PRODUCT_ADVANCED_SEARCH_PRODUCT_TYPES_TRACKING,
        payload: {
            typeLabel
        }
    });
}

const productLinkNameTagging = (type, result, isBuyLink) => (dispatch) => {
    dispatch ({
        type: actionTypes.BROKER_PRODUCT_ADVANCED_SEARCH_LINK_NAME_TRACKING,
        payload: {
            type,
            result,
            isBuyLink
        }
    });
}

module.exports = {
    clearResultsTracking,
    advancedSearchFiltersTracking,
    searchSpecificProductTracking,
    productLinkNameTagging
};
